/**
 * Get the backend storage base URL for accessing images and files
 * In production: https://api.pulseticket.es/storage/
 * In development: /storage/ (proxied by Vite)
 */
export const getBackendStorageBaseUrl = () => {
  if (import.meta.env.DEV) {
    return '/storage/';
  }

  const apiBase = import.meta.env.VITE_API_BASE_URL || 'https://api.pulseticket.es/api';
  const backendBase = apiBase.replace(/\/api\/?$/, '');
  return `${backendBase}/storage/`;
};

/**
 * Build a full storage URL from a relative path
 * @param {string} path - Relative path from storage (e.g., 'event_images/filename.jpg')
 * @returns {string|null} Full URL or null if path is empty
 */
export const buildStorageUrl = (path) => {
  if (!path) return null;
  if (/^(https?:)?\/\//i.test(path) || path.startsWith('data:')) return path;

  const baseUrl = getBackendStorageBaseUrl(); // Already includes /storage/
  const normalizedPath = path.replace(/^\/+/, '').replace(/^storage\/+/i, '');
  return `${baseUrl}${normalizedPath}`;
};
